import React from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "@douyinfe/semi-ui";
import NavHeader from "../nav-header";
import HoverGadget from "@pages/components/hover-gadget";
import styles from "./index.module.scss";
// import Footer from "@layouts/footer";
// import ContactFooter from "@layouts/contact-footer";

const { Content } = Layout;

const NavLayout = () => {
  return (
    <Layout className={styles.layout}>
      <NavHeader />
      <Content className={styles.content}>
        <Outlet />

        <HoverGadget />
      </Content>
      {/* <Footer /> */}
      {/* <ContactFooter /> */}
    </Layout>
  );
};

export default NavLayout;
